import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

function PieChart({ labels, data, backgroundColor, options }) {
  const chartProps = {
    labels,
    datasets: [
      {
        data,
        backgroundColor,
        borderWidth: 3,
      },
    ],
  };
  return (
    <div className="">
      <Doughnut data={chartProps} options={options} />
    </div>
  );
}

export default PieChart;
